import React from 'react';

import Address from '../address';

import './footer.sass';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <Address />
      </div>
    </footer>
  );
};

export default Footer;